import * as React from "react";
import { useSelector } from "react-redux";
import { WidgetFrame, ProgressWidget, ErrataWidget, Locale }
  from "../../personal-studio-components/studio";
import { StudentService } from "../../src/components/studentService";
//import * as cls from "./Sample.module.scss";
export { Sample, SampleModel, SampleView };

/**
 * Компонент.
 * @param {SampleModel} props - Атрибуты элемента.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Sample() {
  const { contractId } = useSelector(state => state.contract);
  const { access_token } = useSelector(state => state.token);
  const [response, setResponse] = React.useState(null);
  const request =
  {
    method: "post",
    path: "/student/info",
    data:
    {
      access_token,
      study_contract_id: contractId,
    }
  };
  React.useEffect(() => { StudentService.send(request, setResponse); },
    [access_token, contractId]);
  if (!response) return <ProgressWidget title={Sample.title} />;
  if (response.errors) return <ErrataWidget errata={response} />;
  const model = new SampleModel(response);
  return <SampleView title={Sample.title} model={model} />;
}

/**
 * Модель компонента.
 */
class SampleModel {

  /**
   * Название.
   * @type {string}
   * @default default
   */
  name = "default";

  /**
   * Копирует свойства объекта.
   * @param {SampleModel} props - Свойства объекта.
   */
  constructor(props) { Object.assign(this, props); }
}

/**
 * Вид компонента.
 * @param {Object} props - Атрибуты элемента.
 * @param {SampleModel} props.model - Модель компонента.
 * @returns {JSX.Element} Элемент JSX.
 */
function SampleView({ title, model }) {
  return (
    <WidgetFrame icon="clipboard_list" title={title}>
      <pre>{JSON.stringify(model, null, "  ")}</pre>
    </WidgetFrame>
  );
}

// Локализация
const locale = new Locale("Sample",
  {
    Sample: "Сервис"
  });

// Заголовок страницы
Sample.title = locale.message("Sample");
